import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useClientUser } from '$logic/client-user'
import { useBrowserConnectionState } from '$hooks/use-browser-connection'
import { authStorage } from '$logic/auth/storage'

export function useStartup() {
  const clientUser = useClientUser()

  useEffect(() => {
    if (!clientUser || !clientUser.id) return
    const auth = authStorage.get()
    if (auth && !auth?.userId) {
      Sentry.setUser({ id: clientUser.id })
      authStorage.set({ ...auth, userId: clientUser.id })
    }
  }, [clientUser])

  useBrowserConnectionState()
}
